import {useStores} from '../stores/useStores';

import { observer } from "mobx-react-lite";
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import * as identityImg from "identity-img";

import Tabs from './Tabs';
import MarketItem from './MarketItem';
import MarketEmptyItem from './MarketEmptyItem';

import "./Address/styles.css";
import { Helmet } from 'react-helmet-async';
import CardStore from 'src/stores/CardStore';

enum TABS {
    ON_SALE='onSale',
    OWNED='owned',
    BIDS='bids'
}

interface IMarketplaceProps {
    location?: Location;
    isWallet?: boolean;
    burn?: boolean;
}

export default observer(function(props: IMarketplaceProps) {
    const { walletStore, accountStore } = useStores();
    let { address } = useParams();

    if (props.isWallet && accountStore.address) {
        address = accountStore.address as string;
    }

    const [version, setVersion] = useState<number>(0);

    const [onSaleNft, setOnSaleNft] = useState<any[]>([]);
    const [ownedNft, setOwnedNft] = useState<any[]>([]);
    const [bidsNft, setBidsNft] = useState<any[]>([]);

    const [onSaleNftSignArt, setOnSaleNftSignArt] = useState<any[]>([]);
    const [ownedNftSignArt, setOwnedNftSignArt] = useState<any[]>([]);

    const [onSaleNftDucks, setOnSaleNftDucks] = useState<any[]>([]);
    const [ownedNftDucks, setOwnedNftDucks] = useState<any[]>([]);

    const [onSaleNftWavesLands, setOnSaleNftWavesLands] = useState<any[]>([]);
    const [ownedNftWavesLands, setOwnedNftWavesLands] = useState<any[]>([]);

    const [onSaleNftWavesDomains, setOnSaleNftWavesDomains] = useState<any[]>([]);
    const [ownedNftWavesDomains, setOwnedNftWavesDomains] = useState<any[]>([]);

    const [activeTab, setActiveTab] = useState<TABS>(TABS.ON_SALE);

    const [userLoaded, setUserLoaded] = useState<boolean>(false);
    const [signArtLoaded, setSignArtLoaded] = useState<boolean>(false);
    const [ducksLoaded, setDucksLoaded] = useState<boolean>(false);
    const [wavesPunksLoaded, setWavesPunksLoaded] = useState<boolean>(false);
    const [wavesLandsLoaded, setWavesLandsLoaded] = useState<boolean>(false);
    const [wavesDomainsLoaded, setWavesDomainsLoaded] = useState<boolean>(false);

    useEffect(() => {
        walletStore.loadAddressNFT(address as string, true).then(() => {
            // load origin
            walletStore.loadUserWallet(address as string).then((data) => {
                const onSale = data.filter(item => item.isOnSell && item.seller === address);
                const owned = data.filter(item => !item.isOnSell);
                const bids = data.filter(item => item.isOnSell && item.seller !== address);
                setOnSaleNft(onSale);
                setOwnedNft(owned);
                setBidsNft(bids);
                setUserLoaded(true);
            });

            // load sign art
            walletStore.loadUserSignArtNfts(address as string).then((data) => {
                const onSale = data.filter(item => item.isOnSell);
                const owned = data.filter(item => !item.isOnSell);
                setOnSaleNftSignArt(onSale);
                setOwnedNftSignArt(owned);
                setSignArtLoaded(true);
            });

            // load ducks
            walletStore.loadDucksNfts(address as string).then((data) => {
                const onSale = data.filter(item => item.isOnSell);
                const owned = data.filter(item => !item.isOnSell);
                setOnSaleNftDucks(onSale);
                setOwnedNftDucks(owned);
                setDucksLoaded(true);
            });

            // load waves punks
            walletStore.loadWavesLandsNfts(address as string).then((data) => {
                const onSale = data.filter(item => item.isOnSell);
                const owned = data.filter(item => !item.isOnSell);
                setOnSaleNftWavesLands(onSale);
                setOwnedNftWavesLands(owned);
                setWavesLandsLoaded(true);
            });

            // loadWavesDomainsNfts
            walletStore.loadWavesDomainsNfts(address as string).then((data) => {
                const onSale = data.filter(item => item.isOnSell);
                const owned = data.filter(item => !item.isOnSell);
                setOnSaleNftWavesDomains(onSale);
                setOwnedNftWavesDomains(owned);
                setWavesDomainsLoaded(true);
            });
        });
    }, [version, address]);

    const accountImage = identityImg.create(address as string, {size: 120})
    const inWallet = accountStore.address === address;

    let onSaleArr = [...onSaleNft, ...onSaleNftSignArt, ...onSaleNftDucks, ...onSaleNftWavesLands, ...onSaleNftWavesDomains];
    let ownedArr = [...ownedNft, ...ownedNftSignArt, ...ownedNftDucks, ...ownedNftWavesLands, ...ownedNftWavesDomains];

    const allLoaded = userLoaded && signArtLoaded && ducksLoaded && wavesPunksLoaded && wavesLandsLoaded && wavesDomainsLoaded;

    if (walletStore.searchValue) {
        const filterFn = (item: CardStore) => {
            const name = item.name.toLowerCase();
            const collection = item.collectionName.toLowerCase();
            return name.indexOf(walletStore.searchValue) >= 0 || collection.indexOf(walletStore.searchValue) >= 0;
        }
        onSaleArr = onSaleArr.filter(filterFn);
        ownedArr = ownedArr.filter(filterFn);
    } else {
        onSaleArr = [...onSaleNft, ...onSaleNftSignArt, ...onSaleNftDucks, ...onSaleNftWavesLands, ...onSaleNftWavesDomains];
        ownedArr = [...ownedNft, ...ownedNftSignArt, ...ownedNftDucks, ...ownedNftWavesLands, ...ownedNftWavesDomains];
    }

    const tabs = [{
        id: TABS.ON_SALE,
        title: 'On sale',
        count: onSaleArr.length || 0,
        active: activeTab === TABS.ON_SALE,
        onClick: (id: string) => {setActiveTab(id as TABS)}
    }, {
        id: TABS.OWNED,
        title: 'Owned',
        count: ownedArr.length || 0,
        active: activeTab === TABS.OWNED,
        onClick: (id: string) => {setActiveTab(id as TABS)}
    }];
    if (bidsNft.length) {
        tabs.push({
            id: TABS.BIDS,
            title: 'Bids',
            count: bidsNft.length || 0,
            active: activeTab === TABS.BIDS,
            onClick: (id: string) => {setActiveTab(id as TABS)}
        });
    }

    return (
        <div className='nftMarketplace-Address'>
            <Helmet>
                <title>Puzzle NFT Market - NFT on address: "{address}"</title>
                <meta name="description" content={'Puzzle NFT Market, NFT on address "' + address + '"'} />
                <meta property="og:title" content={'Puzzle NFT Market - NFT on address: ' + address} />
            </Helmet>
            <div className='nftMarketplace-Address__accountWrap'>
                <div className='nftMarketplace-Address__imageWrap'>
                    <img className='nftMarketplace-Address__image' src={accountImage} alt={address} />
                </div>
                <div className="nftMarketplace-Address__name" title={address}>
                    {address?.substring(3, 0)}...{address?.substring(address.length - 3)}
                    {
                        inWallet ? <div className='nftMarketplace-Address__ownerMark'>You</div> : ''
                    }
                </div>
            </div>
            <Tabs tabs={tabs}/>
            <div className='nftMarketplace-Address__catalog'>
                <div className='puzzle-nftMarketplace'>
                    {
                        activeTab === TABS.ON_SALE ?
                            (onSaleArr.length ?
                                onSaleArr.map((item) => <MarketItem key={item.assetId} item={item} inWallet={inWallet} cb={() => setVersion(version + 1)} />) :
                                (!allLoaded ? <MarketEmptyItem key={1}/> : '')
                            ) :
                            ''
                    }
                    {
                        activeTab === TABS.OWNED ?
                            (ownedArr.length ?
                                ownedArr.map((item) => <MarketItem key={item.assetId} item={item} burn={props.burn} inWallet={inWallet} cb={() => setVersion(version + 1)} />) :
                                (!allLoaded ? <MarketEmptyItem key={1}/> : '')
                            ) :
                            ''
                    }
                    {
                        activeTab === TABS.BIDS ?
                            (bidsNft.length ?
                                bidsNft.map((item) => <MarketItem key={item.assetId} item={item} cb={() => setVersion(version + 1)} />) :
                                (!allLoaded ? <MarketEmptyItem key={1}/> : '')
                            ) :
                            ''
                    }
                </div>
            </div>
        </div>
    );
});
